<template>
  <div class="clearfix">
    <div class="main-container">
      <small :class="{ alternative: alternativeStyle }">{{ $t('Your Worksome balance') }}</small>
      <h2 :class="{ alternative: alternativeStyle }">
        <span>{{ balance }}</span>
      </h2>
    </div>
  </div>
  <slot></slot>
</template>

<script>
export default {
  name: 'BalanceBox',

  props: {
    balance: {
      type: String,
      required: true,
    },
    alternativeStyle: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>

<style scoped lang="scss">
.main-container {
  @apply tw-overflow-hidden;
  padding: 14px 16px 8px 18px;
}

small {
  @apply tw-font-medium;
  @apply tw-block;
  @apply tw-text-white;
  @apply tw-opacity-50;
  margin-bottom: 3px;

  &.alternative {
    @apply tw-text-black;
    @apply tw-opacity-100;
  }
}

h2 {
  @apply tw-overflow-hidden;
  @apply tw-whitespace-nowrap;
  @apply tw-font-light;
  @apply tw-text-white;
  @apply tw-text-ellipsis;
  margin: 0 0 0.5rem;
  line-height: 100%;
  font-size: 22px;

  &.alternative {
    @apply tw-text-black;
  }
}
</style>
